const TITULO_PROG_LIST = "Programas";
const TITULO_PROG_REG = "Registrar programa";

const TITULO_EST_LIST = "Estudiantes";
const TITULO_EST_REG = "Registrar estudiante";
const TITULO_EST_ACT = "Actualizar Estudiante";
const TITULO_EST_MOD = "Asignar grupos";

const TITULO_DOC_LIST = "Docentes";
const TITULO_DOC_REG = "Registrar docente";

const TITULO_IDIOMA_LIST = "Idiomas";
const TITULO_IDIOMA_REG = "Registrar idioma";

const TITULO_GRUPO_LIST = "Grupos";
const TITULO_GRUPO_REG = "Registrar grupo";

const TITULO_PROGRAMA_LIST = "Programas";
const TITULO_PROGRAMA_REG = "Registrar programa";

const TITULO_REP_LIST = "Reportes";
const TITULO_TURNO_LIST = "Turnos";
const TITULO_MODALIDAD_LIST = "Modalidades";
const TITULO_HORARIO_REG = "Registrar horario";
const TITULO_HORARIO_LIST = "Horarios";
const TITULO_IDIOMA_DETALLE = "Módulos";

const generosPersona = [{
  value: "Masculino",
  label: "Masculino",
}, {
  value: "Femenino",
  label: "Femenino",
}, {
  value: "Otro",
  label: "Prefiero no decirlo",
},]

const TIPO_ADMISION_B = "Becario"

export {
  TITULO_PROG_LIST,
  TITULO_PROG_REG,
  TITULO_EST_LIST,
  TITULO_EST_REG,
  TITULO_DOC_LIST,
  TITULO_DOC_REG,
  TITULO_REP_LIST,
  TITULO_EST_MOD,
  TITULO_GRUPO_LIST,
  TITULO_GRUPO_REG,
  TITULO_IDIOMA_LIST,
  TITULO_IDIOMA_REG,
  TITULO_PROGRAMA_LIST,
  TITULO_PROGRAMA_REG,
  generosPersona,
  TITULO_TURNO_LIST,
  TITULO_MODALIDAD_LIST,
  TITULO_HORARIO_REG,
  TITULO_HORARIO_LIST,
  TIPO_ADMISION_B,
  TITULO_IDIOMA_DETALLE,
  TITULO_EST_ACT
};